<header
  #navbar
  class="fixed inset-x-0 top-0 z-50 transition-all duration-300 ease-out"
  [ngClass]="{
    'bg-transparent backdrop-blur-0 shadow-none': isHomePage && !isScrolled,
    'bg-white/95 backdrop-blur-xl shadow-lg': !isHomePage || isScrolled
  }"
>
  <div class="mx-auto flex h-20 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
    <!-- Logo -->
    <div class="flex items-center gap-3">
      <a
        routerLink="/"
        class="flex items-center"
        [ngClass]="{
          'text-white': isHomePage && !isScrolled,
          'text-slate-900': !isHomePage || isScrolled
        }"
      >
        <svg class="h-10 w-auto" viewBox="0 0 650 150" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gradD" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <linearGradient id="gradA" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0.3s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0.3s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <linearGradient id="gradN" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0.6s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0.6s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <linearGradient id="gradC" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0.9s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="0.9s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <linearGradient id="gradE" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="1.2s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="1.2s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <linearGradient id="gradU" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="1.5s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="1.5s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <linearGradient id="gradP" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#6366f1">
                <animate
                  attributeName="stop-color"
                  values="#6366f1;#ec4899;#ec4899;#6366f1;#6366f1"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="1.8s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="100%" stop-color="#ec4899">
                <animate
                  attributeName="stop-color"
                  values="#ec4899;#6366f1;#6366f1;#ec4899;#ec4899"
                  keyTimes="0;0.4;0.6;0.8;1"
                  dur="6s"
                  begin="1.8s"
                  repeatCount="indefinite"
                />
              </stop>
            </linearGradient>

            <style>
              .letter {
                font-size: 100px;
                font-family: 'Arial Black', sans-serif;
                opacity: 0;
                letter-spacing: 12px;
              }
            </style>
          </defs>

          <text x="20" y="100" class="letter" fill="url(#gradD)">
            D
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
          </text>
          <text x="110" y="100" class="letter" fill="url(#gradA)">
            A
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.3s" fill="freeze" />
          </text>
          <text x="200" y="100" class="letter" fill="url(#gradN)">
            N
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.6s" fill="freeze" />
          </text>
          <text x="290" y="100" class="letter" fill="url(#gradC)">
            C
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.9s" fill="freeze" />
          </text>
          <text x="380" y="100" class="letter" fill="url(#gradE)">
            E
            <animate
              attributeName="opacity"
              from="0"
              to="1"
              dur="0.5s"
              begin="1.2s"
              fill="freeze"
            />
          </text>
          <text x="470" y="100" class="letter" fill="url(#gradU)">
            U
            <animate
              attributeName="opacity"
              from="0"
              to="1"
              dur="0.5s"
              begin="1.5s"
              fill="freeze"
            />
          </text>
          <text x="560" y="100" class="letter" fill="url(#gradP)">
            P
            <animate
              attributeName="opacity"
              from="0"
              to="1"
              dur="0.5s"
              begin="1.8s"
              fill="freeze"
            />
          </text>
        </svg>
      </a>
    </div>

    <!-- Desktop Navigation -->
    <div class="hidden items-center gap-8 md:flex">
      <nav class="flex items-center gap-6 text-sm font-medium">
        <a routerLink="/classes" class="transition-all duration-200 hover:-translate-y-0.5 hover:text-amber-400" routerLinkActive="text-amber-400">
          Classes
        </a>
        <a routerLink="/events" class="transition-all duration-200 hover:-translate-y-0.5 hover:text-amber-400" routerLinkActive="text-amber-400">
          Events
        </a>
        <a routerLink="/studios" class="transition-all duration-200 hover:-translate-y-0.5 hover:text-amber-400" routerLinkActive="text-amber-400">
          Studios
        </a>
        <a href="https://studios.danceup.app" class="transition-all duration-200 hover:-translate-y-0.5 hover:text-amber-400">
          Studio Owners
        </a>
      </nav>

      <div class="flex items-center gap-4">
        <!-- Signed-in state -->
        <ng-container *ngIf="user as currentUser; else authLinks">
        <div
          class="group relative flex items-center gap-3 rounded-lg px-2 py-1 transition-colors duration-200 hover:bg-white/10"
        >
          <div class="flex items-center gap-3">
            <div class="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-sm font-semibold text-white">
              <img
                *ngIf="getUserPhotoUrl(); else initials"
                [src]="getUserPhotoUrl()"
                [alt]="getUserDisplayName() + ' profile picture'"
                class="h-full w-full object-cover"
              />
              <ng-template #initials>
                {{ getUserInitials() }}
              </ng-template>
            </div>
            <div class="flex flex-col">
              <span class="text-sm font-semibold leading-tight text-white" [ngClass]="{'text-slate-900': !isHomePage || isScrolled}">
                {{ getUserDisplayName() }}
              </span>
            </div>
          </div>

          <div
            class="invisible absolute right-0 top-full mt-3 w-48 rounded-xl border border-slate-200/60 bg-white/95 p-2 text-sm opacity-0 shadow-2xl backdrop-blur-xl transition-all duration-200 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100"
          >
            <a
              routerLink="/dashboard"
              class="flex items-center rounded-lg px-3 py-2 font-medium text-slate-700 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
              (click)="closeMenu()"
            >
              Dashboard
            </a>
            <a
              routerLink="/profile"
              class="flex items-center rounded-lg px-3 py-2 font-medium text-slate-700 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
              (click)="closeMenu()"
            >
              Profile
            </a>
            <button
              type="button"
              class="flex w-full items-center rounded-lg px-3 py-2 font-medium text-slate-700 transition-colors hover:bg-rose-50 hover:text-rose-500"
              (click)="logout()"
            >
              Logout
            </button>
          </div>
        </div>
        </ng-container>

        <!-- Guest state -->
        <ng-template #authLinks>
          <div class="flex items-center gap-3">
            <a
              [routerLink]="['/login']"
              [queryParams]="{ returnUrl: getCurrentUrl() }"
              class="rounded-lg border border-white/30 px-4 py-2 text-sm font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:border-white/60 hover:bg-white/10"
              [ngClass]="{
                'border-white/30 text-white hover:border-white/60 hover:bg-white/10': isHomePage && !isScrolled,
                'border-slate-300 text-slate-900 hover:border-indigo-400 hover:bg-indigo-50': !isHomePage || isScrolled
              }"
            >
              Login
            </a>
            <a
              [routerLink]="['/register']"
              [queryParams]="{ returnUrl: getCurrentUrl() }"
              class="rounded-lg border border-transparent bg-gradient-to-r from-amber-400 to-orange-500 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
            >
              Sign Up
            </a>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Mobile menu button -->
    <button
      type="button"
      class="flex h-11 w-11 items-center justify-center rounded-md border border-white/30 transition-all duration-200 hover:border-white/60 md:hidden"
      [ngClass]="{
        'border-white/40 bg-black/30 text-white hover:border-white/80 hover:bg-black/40': isHomePage && !isScrolled,
        'border-slate-300 text-slate-900 hover:border-slate-500': !isHomePage || isScrolled
      }"
      (click)="toggleMenu()"
      aria-label="Toggle mobile menu"
    >
      <div class="relative h-5 w-6">
        <span
          class="absolute left-0 h-0.5 w-full origin-center transform transition duration-300"
          [ngClass]="{
            'translate-y-0 rotate-0': !isMenuOpen,
            'translate-y-2.5 rotate-45': isMenuOpen,
            'bg-white': isHomePage && !isScrolled,
            'bg-slate-900': !isHomePage || isScrolled
          }"
        ></span>
        <span
          class="absolute left-0 h-0.5 w-full origin-center transform transition duration-300"
          [ngClass]="{
            'translate-y-2': !isMenuOpen,
            'opacity-0': isMenuOpen,
            'bg-white': isHomePage && !isScrolled,
            'bg-slate-900': !isHomePage || isScrolled
          }"
        ></span>
        <span
          class="absolute left-0 h-0.5 w-full origin-center transform transition duration-300"
          [ngClass]="{
            'translate-y-4 rotate-0': !isMenuOpen,
            'translate-y-2.5 rotate-[-45deg]': isMenuOpen,
            'bg-white': isHomePage && !isScrolled,
            'bg-slate-900': !isHomePage || isScrolled
          }"
        ></span>
      </div>
    </button>
  </div>

  <!-- Mobile Navigation -->
  <div
    class="md:hidden overflow-hidden transition-all duration-300 ease-in-out"
    [ngClass]="{
      'max-h-0 opacity-0 pointer-events-none': !isMenuOpen,
      'max-h-[800px] opacity-100 pointer-events-auto': isMenuOpen
    }"
  >
    <div
      class="mx-4 mb-6 mt-4 space-y-4 rounded-2xl border border-white/20 bg-white/95 p-6 text-sm font-medium text-slate-700 shadow-xl backdrop-blur-xl"
      [ngClass]="{
        'mt-0 mb-0': !isMenuOpen
      }"
    >
      <nav class="flex flex-col gap-3">
        <a
          routerLink="/classes"
          class="rounded-xl px-4 py-3 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
          routerLinkActive="bg-indigo-50 text-indigo-600"
          (click)="closeMenu()"
        >
          Classes
        </a>
        <a
          routerLink="/events"
          class="rounded-xl px-4 py-3 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
          routerLinkActive="bg-indigo-50 text-indigo-600"
          (click)="closeMenu()"
        >
          Events
        </a>
        <a
          routerLink="/studios"
          class="rounded-xl px-4 py-3 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
          routerLinkActive="bg-indigo-50 text-indigo-600"
          (click)="closeMenu()"
        >
          Studios
        </a>
        <a
          href="https://studios.danceup.app"
          class="rounded-xl px-4 py-3 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
          (click)="closeMenu()"
        >
          Studio Owners
        </a>
      </nav>

      <div class="border-t border-slate-200 pt-4">
        <ng-container *ngIf="user as mobileUser; else mobileAuth">
        <div class="space-y-4">
          <div class="flex items-center gap-3">
            <div class="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-base font-semibold text-white">
              <img
                *ngIf="getUserPhotoUrl(); else mobileInitials"
                [src]="getUserPhotoUrl()"
                [alt]="getUserDisplayName() + ' profile picture'"
                class="h-full w-full object-cover"
              />
              <ng-template #mobileInitials>
                {{ getUserInitials() }}
              </ng-template>
            </div>
            <div class="flex flex-col">
              <span class="text-base font-semibold text-slate-900">
                {{ getUserDisplayName() }}
              </span>
              <span class="text-xs text-slate-500">
                Welcome back
              </span>
            </div>
          </div>

          <div class="space-y-2">
            <a
              routerLink="/dashboard"
              class="block rounded-xl px-4 py-3 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
              (click)="closeMenu()"
            >
              Dashboard
            </a>
            <a
              routerLink="/profile"
              class="block rounded-xl px-4 py-3 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
              (click)="closeMenu()"
            >
              Profile
            </a>
            <button
              type="button"
              class="block w-full rounded-xl px-4 py-3 text-left text-rose-500 transition-colors hover:bg-rose-50"
              (click)="logout()"
            >
              Logout
            </button>
          </div>
        </div>
        </ng-container>

        <ng-template #mobileAuth>
          <div class="flex flex-col gap-3 pt-2">
            <a
              [routerLink]="['/login']"
              [queryParams]="{ returnUrl: getCurrentUrl() }"
              class="rounded-xl border border-slate-300 px-4 py-3 text-center font-semibold text-slate-900 transition-colors hover:border-indigo-400 hover:bg-indigo-50 hover:text-indigo-600"
              (click)="closeMenu()"
            >
              Login
            </a>
            <a
              [routerLink]="['/register']"
              [queryParams]="{ returnUrl: getCurrentUrl() }"
              class="rounded-xl border border-transparent bg-gradient-to-r from-amber-400 to-orange-500 px-4 py-3 text-center font-semibold text-white shadow-lg transition-all hover:-translate-y-0.5 hover:shadow-xl"
              (click)="closeMenu()"
            >
              Sign Up
            </a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</header>
